

import React, { Component } from 'react';
import { Header, Table } from 'semantic-ui-react';
import Images from '../../../../../../config/images'
import { get, isEmpty } from "lodash";
class PrintDailyCanada extends Component {
    constructor() {
        super();
        this.state = {
            values: [],
            activeIndex: -1,
            disabled: {},
            loading: false,
        }
    }

    handleClick = () => {
        const { cbpDailyIndex } = this.props
        const { activeIndex } = this.state
        const newIndex = activeIndex === cbpDailyIndex ? -1 : cbpDailyIndex

        this.setState({ activeIndex: newIndex })
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    handleRemove = (e, { name, value }) => {
        if (value === 'remove') {
            this.setState({ [name]: true })
        }
    }

    formatPrintDate = (date) => {
        return date.split(" ", 1)
    }

    formatMoney = (num) => {
        let value = num && !isEmpty(num) && num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        if (value === 'NaN') {
          value='0.00'
        }
        return value;
    }

    render() {

        const { cbpDailyData } = this.props


        let transactionNumber = 0, Port = 0, duty = 0, sima = 0, excise = 0, gst = 0, interest = 0, penalty = 0, total = 0;
        if(cbpDailyData.statementEntries) {
            for(let i = 0; i < cbpDailyData.statementEntries.length ; i ++) {

                Port += cbpDailyData.statementEntries[i].Port;
                duty += cbpDailyData.statementEntries[i].duty?parseFloat(cbpDailyData.statementEntries[i].duty):0;
                sima += cbpDailyData.statementEntries[i].sima?parseFloat(cbpDailyData.statementEntries[i].sima):0;
                excise += cbpDailyData.statementEntries[i].excise?parseFloat(cbpDailyData.statementEntries[i].excise):0;
                gst += cbpDailyData.statementEntries[i].gst?parseFloat(cbpDailyData.statementEntries[i].gst):0;
                penalty += cbpDailyData.statementEntries[i].penalty?parseFloat(cbpDailyData.statementEntries[i].penalty):0;
                interest += cbpDailyData.statementEntries[i].interest?parseFloat(cbpDailyData.statementEntries[i].interest):0;
                total += cbpDailyData.statementEntries[i].b3Total?parseFloat(cbpDailyData.statementEntries[i].b3Total):0;
            }
        }
        return (
            <center>
                <div className='invoicePrint'>
                    <div className='printHeader'>
                        <img style={{ width: '150px' }} src={Images.newknlogo} />
                    </div>
                    <div className='cbpPaymentSectionHeaderDiv'>
                       
                        <div className='headerSectionFourPrint'>
                            <Header className='cbpHeaderText top' as='h5'>DN DATE</Header>
                            <Header className='cbpHeaderText' as='h4'>
                                {this.formatPrintDate(cbpDailyData.DN_DATE || 'N/A')}
                            </Header>
                        </div>
                        <div className='headerSectionFourPrint'>
                            <Header className='cbpHeaderText top' as='h5'>IMPORTER</Header>
                            <Header className='cbpHeaderText' as='h4'>
                                {cbpDailyData.importerName}
                            </Header>
                        </div>
                        <div className='headerSectionAmountPrint'>
                            <Header className='cbpHeaderText top' as='h5'>AMOUNT</Header>
                            <Header className='cbpHeaderText' as='h4'>
                                ${this.formatMoney((parseFloat(cbpDailyData.b3nTotal_due)).toFixed(2))}
                            </Header>
                        </div>
                        
                    </div>
                    {/* </Accordion.Title>
                    <Accordion.Content active={activeIndex === cbpDailyIndex} > */}
                    <Table basic='very' selectable>
                        <Table.Header>
                            <Table.Row>
                            <Table.HeaderCell>TRANSACTION NUMBER</Table.HeaderCell>
                              <Table.HeaderCell>CARGO CONTROL NUMBER</Table.HeaderCell>
                              <Table.HeaderCell>PURCHASE ORDER</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>DOC TYPE</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>PORT</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>DUTY</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>SIMA</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>EXCISE</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>GST</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>PENALTY</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>INTEREST</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>TOTAL</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                        { cbpDailyData.statementEntries ? cbpDailyData.statementEntries.map((item, i) => (
                                  <Table.Row style={{cursor: 'pointer'}} onClick={this.props.open} disabled={this.state.i} key={i}>
                                    <Table.Cell>{get(item,"transactionNumber",0)}</Table.Cell>
                                    <Table.Cell>{get(item,"cargoControlNumber",0)}</Table.Cell>
                                    <Table.Cell>{get(item,"poNumber",0)}</Table.Cell>
                                    <Table.Cell textAlign='right'>{get(item,"docType",0)}</Table.Cell>
                                    <Table.Cell textAlign='right'>{get(item,"Port",0)}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {get(item,"duty",0)}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {get(item,"sima",0)}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {get(item,"excise",0)}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {get(item,"gst",0)}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {get(item,"penalty",0)}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {get(item,"interest",0)}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {get(item,"b3Total",0)}</Table.Cell>
                                  </Table.Row>
                              )) : null }
                        
                                <Table.Row className="totalRow" style={{cursor: 'pointer'}} onClick={this.props.open} >
                                    <Table.Cell><div className="total_label">TOTAL</div></Table.Cell>
                                    <Table.Cell></Table.Cell>
                                    <Table.Cell></Table.Cell>
                                    <Table.Cell textAlign='right'></Table.Cell>
                                    <Table.Cell textAlign='right'></Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {duty.toFixed(2)}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {sima.toFixed(2)}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {excise.toFixed(2)}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {gst.toFixed(2)}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {penalty.toFixed(2)}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {interest.toFixed(2)}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {total.toFixed(2)}</Table.Cell>
                                </Table.Row>
                        </Table.Body>
                    </Table>
                    <br /><br /><br />

                </div>
            </center>
        )
    }
}

export default PrintDailyCanada;